















































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {
    RateRuleEditModel,
    RateRuleLookupModel,
} from '@/services/api/nswag/stapiclient_generated';
import RateRuleSelect from '@/views/RateRules/RateRuleSelect.vue';
import RateRuleProjectSelect from '@/views/RateRules/RateRuleProjectSelect.vue';
import {RateRuleEditValidation} from '@/views/RateRules/RateRuleEditValidation';
import {stRateRuleApi} from '@/services/st-api';
import {UserStore} from '@/store/user-module';
import RateRuleSelectNested from '@/views/RateRules/RateRuleSelectNested/RateRuleSelectNested.vue';

@Component({
    components: {
        RateRuleSelect, RateRuleProjectSelect, RateRuleSelectNested
    },
})
export default class RateRuleEdit extends Vue {
    @Prop()item!:RateRuleEditModel;

    lookups:RateRuleLookupModel = RateRuleLookupModel.fromJS({});

    filterCustomers:boolean = false;
    filterProjectTasks:boolean = false;
    filterAppUsers:boolean = false;

    get currency(){
        return this.settings.currency;
    }

    get settings(){
        return UserStore.userSettings;
    }

    get noFilterSelected(){
        return (!this.filterCustomers && !this.filterProjectTasks && !this.filterAppUsers)
    }

    get ruleIsInvalid(){
        return (!this.item.customerIds?.length && !this.item.appUserIds?.length && !this.item.projectTaskIds?.length);
    }

    private async loadLookups(){
        this.lookups = (await stRateRuleApi.getLookpus(this.item.parentRateRuleId!, this.item.id!));
        this.setFilterBools();

        //Child Rule filtert auf ungefiltertes Parent Element
        //Wenn dann Parent "geöffnet" wird, müssen die items gesetzt werden
        RateRuleEditValidation.SetItemsParentNotSelected(this.item, this.lookups);
    }

    private setFilterBools(){
        this.filterCustomers = !!this.item.customerIds && this.item.customerIds.length > 0;
        this.filterProjectTasks = !!this.item.projectTaskIds && this.item.projectTaskIds.length > 0;
        this.filterAppUsers = !!this.item.appUserIds && this.item.appUserIds.length > 0;
    }

    @Watch('item')
    async itemChanged(){
        if(this.item){
            await this.loadLookups();
        }
    }

    // @Watch('item.customerIds')
    // test(){
    //   console.log(this.item.customerIds)
    // }

    async mounted(){
        if(this.item){
            await this.loadLookups();
        }
    }

    async submit(){

        if(!this.filterCustomers){
            this.item.customerIds = [];
        }

        if(!this.filterAppUsers){
            this.item.appUserIds = [];
        }

        if(!this.filterProjectTasks){
            this.item.projectTaskIds = [];
        }

        this.item.customerIds?.forEach(x=>x.allSelected?x.nestedIds =[]:null);

        if(this.item.id == 0){
            await stRateRuleApi.post(this.item);
        }else{
            await stRateRuleApi.put(this.item.id, this.item);
        }

    }
}
